function Quiffce() {
  var me = this;
  me.addQRProduct = async (productid, code) => {
    const formPData = new FormData();
    const produrl = `https://www.quiffice.com/nl/cart/add/${productid}/`;
    const sendprod = { url: produrl, method: "POST" };
    formPData.append("quantity", 1);
    sendprod.body = formPData; //bundle_id
    console.log(`send data ${sendprod.url}`);
    await me.fetch(sendprod);
    document.querySelector("body").classList.add("addproduct");
    const formData = new FormData();
    const sendcode = {
      url: "https://www.quiffice.com/nl/cart/setDiscount/",
      method: "POST",
    };
    formData.append("code", code);
    console.log("send data");
    sendcode.body = formData;
    await me.fetch(sendcode);
    document.querySelector("body").classList.add("addcode");
    return true;
  };
  me.showShortVideo = (id) => {
    let vw = document.querySelector(id);
    let v =
      vw.querySelector(`${id} >deferred-media`) ||
      me.createVideo(vw, vw.dataset.videourl);
    vw.classList.remove("close");
  };
  me.pauseShortVideo = (id) => {
    let vw = document.querySelector(id);
    if (vw.tagName.toLowerCase() != "video")
      vw = document.querySelector(`${id} video`);
    if (vw) vw.pause();
  };
  me.createVideo = (vw, src) => {
    let v = document.createElement("video");
    v.autoplay = "autoplay";
    v.muted = "";
    v.controls = "controls";
    v.width = "694";
    v.style.opacity = 0;
    let s = document.createElement("source");

    v.addEventListener("loadeddata", () => {
      v.style.opacity = 1;
    });

    s.type = "video/mp4";
    s.src = src;
    v.appendChild(s);

    vw.prepend(v);

    return v;
  };
  me.startVisibleCheck = () => {
    isVisible.forEach((el) => {
      let inview = me.isElementXPercentInViewport(el, 0);
      if (inview) {
        el.classList.add("isVisible");
        el.classList.add("beenVisible");
      }
      observer.observe(el);
    });
  };
  me.isElementInViewport = (el) => {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  me.isElementXPercentInViewport = function (el, percentVisible) {
    let rect = el.getBoundingClientRect(),
      windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

    return !(
      Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
        percentVisible ||
      Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
        percentVisible
    );
  };
  me.fetch = async (obj) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || "GET", obj.url);
      if (obj.headers) {
        Object.keys(obj.headers).forEach((key) => {
          xhr.setRequestHeader(key, obj.headers[key]);
        });
      }
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else {
          reject(xhr.statusText);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
    });
  };
  const isVisible = document.querySelectorAll(".checkVisible");
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        entries[0].target.classList.add("isVisible");
        entries[0].target.classList.add("beenVisible");
      } else {
        // el is not visible
        entries[0].target.classList.remove("isVisible");
      }
    },
    { threshold: 0.2 }
  );
  function reverseString(str) {
    return str === "" ? "" : reverseString(str.substr(1)) + str.charAt(0);
  }
  me.startVisibleCheck();
}
const quiffce = new Quiffce();
